import React from "react";
import Button from "react-bootstrap/es/Button";
import {Col, Row} from "react-bootstrap";
import {InputWithLabel} from "../component/Form/InputWithLabel";
import {dayMonthYearAtTimeWithSeconds} from "../utils/dates";

class GridGateway {
  title = 'Lista de Gateways';
  showNewButton = false;
  customFilters = {}
  columns = [
    {
      Header: "Nome",
      accessor: "friendlyName",
      HeaderColumn: true
    },
    {
      Header: "UUID",
      accessor: "uuid"
    },
    {
      Header: "Data de criação",
      accessor: "createdAt",
      Cell: row => row.original.createdAt && dayMonthYearAtTimeWithSeconds(row.original.createdAt)
    },
    {
      Header: "Opções",
      sortable: false,
      filterable: false,
      export: false,
      Cell: row => (
          <a href={"#/gateways/" + row.original.id + "/edit"}>
            <Button bsStyle="success" block>Editar</Button>
          </a>
      ),
    }
  ];

  customFilterComponent = (_props, _state, onChange) => {
    const handleSimpleInput = (customFilterProperty, value) => {
      this.customFilters[customFilterProperty] = value;
      onChange(this.customFilters);
    }

    return (
      <Row className="align-items-center">
        <Col md={4}>
          <InputWithLabel
            label="Nome"
            onChangeText={text => handleSimpleInput('friendlyName', text)}
          />
        </Col>
        <Col md={4}>
          <InputWithLabel
            label="UUID"
            onChangeText={text => handleSimpleInput('uuid', text)}
          />
        </Col>
      </Row>
    )
  }

  endpoint = () => {
    const params = new URLSearchParams({})
    const {friendlyName, uuid} = this.customFilters

    friendlyName && params.append('friendlyName', friendlyName)
    uuid && params.append('uuid', uuid)

    return `cloud/v1/gateways?${params.toString()}`;

  }
}

export default GridGateway;



// WEBPACK FOOTER //
// ./src/gateways/GridGateway.js